export const OBRAS_DEFAULT = ['Benjamin Constant', 'Lumière', 'Ingarden', 'Escritório', 'Manutenção', 'Externo'];
export const TENSOES_DEFAULT = ['110V', '220V', 'Bivolt', 'N/A'];

export const STATUS_CONFIG = {
  disponivel:  { label: 'Disponível',  color: 'bg-green-100 text-green-700' },
  em_uso:      { label: 'Em uso',      color: 'bg-blue-100 text-blue-700' },
  manutencao:  { label: 'Manutenção',  color: 'bg-yellow-100 text-yellow-700' },
  descartado:  { label: 'Descartado',  color: 'bg-gray-100 text-gray-500' },
  emprestado:  { label: 'Emprestado',  color: 'bg-purple-100 text-purple-700' },
};

export const TIPO_MOV_CONFIG = {
  cadastro:          { label: 'Cadastro',            color: 'text-gray-500' },
  retirada:          { label: 'Retirada',            color: 'text-blue-600' },
  devolucao:         { label: 'Devolução',           color: 'text-green-600' },
  transferencia:     { label: 'Transferência',       color: 'text-indigo-600' },
  manutencao_entrada:{ label: 'Entrada Manutenção',  color: 'text-yellow-600' },
  manutencao_saida:  { label: 'Saída Manutenção',    color: 'text-teal-600' },
  descarte:            { label: 'Descarte',            color: 'text-red-600' },
  emprestimo:          { label: 'Empréstimo',          color: 'text-purple-600' },
  saida_funcionario:   { label: 'Saída (funcionário)', color: 'text-orange-600' },
  checkin_funcionario: { label: 'Devolução (func.)',   color: 'text-green-600' },
  troca_qr:            { label: 'Troca de QR Code',   color: 'text-violet-600' },
};

export function StatusBadge({ status }) {
  const cfg = STATUS_CONFIG[status] || { label: status, color: 'bg-gray-100 text-gray-500' };
  return <span className={`inline-flex items-center px-2 py-0.5 rounded-full text-xs font-medium ${cfg.color}`}>{cfg.label}</span>;
}
